import React from 'react';
import styled from 'styled-components';
import { themes, utils } from 'kb-shared';
import Option from './Option';
import HelpText from 'screens/Book/components/HelpText';
import { BookingQuizAnswer } from '..';
const { breakpoints } = themes;

interface Props {
  options: Array<BookingQuizAnswer>;
  large: boolean;
  onSelect: (opt: BookingQuizAnswer) => void;
  isLoggedIn: boolean;
}

const OptionsList = ({ options, large, onSelect, isLoggedIn }: Props) => (
  <>
    {large ? (
      <FlexWrapper>
        {options.map((opt: BookingQuizAnswer) => (
          <LargeOption key={opt.text} onClick={() => onSelect(opt)}>
            <Option {...opt} />
          </LargeOption>
        ))}
      </FlexWrapper>
    ) : (
      <VerticalWrapper>
        {options.map((opt: BookingQuizAnswer) => (
          <MediumOption key={opt.text} onClick={() => onSelect(opt)}>
            <Option text={opt.text} />
          </MediumOption>
        ))}
      </VerticalWrapper>
    )}
    {!isLoggedIn && (
      <HelpText
        text="Not sure which option?"
        linkText="Contact us"
        linkUrl={`mailto:${utils.KBContacts.navigatorEmail}?subject=Appointment Booking Question`}
      />
    )}
  </>
);

export default OptionsList;

const LargeOption = styled.button`
  padding: 2em;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 4px;
  margin: 1em;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  text-align: center;
  cursor: pointer;
  min-height: min-content;

  &:hover,
  &:focus {
    border: 2px solid ${({ theme }) => theme.colors.yellow};
    outline: none;
  }
`;

const FlexWrapper = styled.ul`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${breakpoints.tabletLandscape}) {
    flex-direction: row;
  }
`;

const MediumOption = styled.button`
  padding: 1em 2em;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 4px;
  margin: 0.5em;
  font-weight: bold;
  max-width: 525px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  &:hover,
  &:focus {
    border: 2px solid ${({ theme }) => theme.colors.yellow};
    outline: none;
  }
`;

const VerticalWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
